// NPA = true (force generic) UNLESS:
//   - user has explicitly opted in, AND
//   - either we're outside the consent region, OR consent.ads is explicitly true
// Both signals must be present for personalized ads to flow.
export function resolveNpa(input: {
  inConsentRegion: boolean
  consentAds: boolean | null
  personalizedAdsOptIn: boolean
}): boolean {
  const { inConsentRegion, consentAds, personalizedAdsOptIn } = input
  if (!personalizedAdsOptIn) return true
  if (inConsentRegion && consentAds !== true) return true
  return false
}
